import { Stack, Text } from "@fluentui/react";
import { BreakpointType } from "../../../Container/ContainerFluid";
import { useBreakpoint } from "../../../Container/ContainerStyles";
import { RegisterMigration, RegisterMigrationRow } from "./Components/RegisterMigrationRow";
import { useEffect, useState } from "react";
import { RegisterTextField } from "../Common/RegisterField";
import { containerStyles, formContainerStyles, lgContainerStyles, lgSubTitleStyles, lgTitleContainerStyles, lgTitleStyles, mdContainerStyles, mdSubTitleStyles, mdTitleContainerStyles, mdTitleStyles, smContainerStyles, smSubTitleStyles, smTitleContainerStyles, smTitleStyles, subTitleStyles, titleContainerStyles, titleStyles, xlContainerStyles, xlSubTitleStyles, xlTitleContainerStyles, xlTitleStyles, xxlContainerStyles, xxlSubTitleStyles, xxlTitleContainerStyles, xxlTitleStyles } from "../Common/Styles/CommonStyles";
import { smTextFieldStyles, mdTextFieldStyles, textFieldStyles, listContainerStyles, smListContainerStyles, mdListContainerStyles, lgListContainerStyles, xlListContainerStyles, xxlListContainerStyles } from "./Styles/RegisterMigrationsStyles";
import { IRegisterContext, useRegisterContext } from "../../RegisterContainer";
import { CrmLostRiskLine } from "../../../LeadDashboard/LeadDashboard";
import { t } from "i18next";
import { MigrationLostRiskLineDetail } from "../../../../../Model/CommonModel";
import { Row } from "../../../Container/Grid/Row";
import { Col, col12 } from "../../../Container/Grid/Col";
import { RegisterService } from "../../Service/RegisterService";

export const RegisterMigrations: React.FC = () => {
    const isSM = useBreakpoint(BreakpointType.sm);
    const isMD = useBreakpoint(BreakpointType.md);
    const isLG = useBreakpoint(BreakpointType.lg);
    const isXL = useBreakpoint(BreakpointType.xl);
    const isXXL = useBreakpoint(BreakpointType.xxl);
    
    const registerContext: IRegisterContext = useRegisterContext(); 
    const [currentERPName, setCurrentERPName] = useState<string>(registerContext.leadToLive.lead.currentERPName);
    const [migrations, setMigrations] = useState<MigrationLostRiskLineDetail[]>(
        () : MigrationLostRiskLineDetail[] => {
            let migrationListItem: MigrationLostRiskLineDetail[] = [
                {
                    id: 10000,
                    description: t('common:qualification:Text0029Lbl'),
                    selected: false
                },
                {
                    id: 20000,
                    description: t('common:qualification:Text0030Lbl'),
                    selected: false
                },
                {
                    id: 30000,
                    description: t('common:qualification:Text0031Lbl'),
                    selected: false
                },
                {
                    id: 40000,
                    description: t('common:qualification:Text0032Lbl'),
                    selected: false
                },
                {
                    id: 50000,
                    description: t('common:qualification:Text0033Lbl'),
                    selected: false
                },
                {
                    id: 60000,
                    description: t('common:qualification:Text0034Lbl'),
                    selected: false
                },
                {
                    id: 70000,
                    description: t('common:qualification:Text0035Lbl'),
                    selected: false
                }
            ];
        
            migrationListItem.forEach((item: MigrationLostRiskLineDetail) => {
                let index: number = registerContext.leadToLive.leadToLiveQualificationDetails.migrationRiskLines.findIndex(e => e.id == item.id);
                if(index >= 0){
                    item.selected = true;
                }
            });
            
            return migrationListItem;
    });

    //Save the selected migrations & current ERP name
    const handleChanged = (currentErpName: string, current?: RegisterMigration) => {
        let migrationLossRisklines: MigrationLostRiskLineDetail[] = [];
        let newMigrations = migrations;

        if(current){
            newMigrations = migrations.map(m => 
                m.id === current.id ? current : m
            );

            newMigrations.filter(e => e.selected).forEach((value: RegisterMigration, index: number, array: RegisterMigration[]) => {
                migrationLossRisklines.push(value);
            });
        }
        else
            migrationLossRisklines = migrations.filter(e => e.selected);

        registerContext.setLeadToLive({
            ...registerContext.leadToLive,
            leadToLiveQualificationDetails: {
                ...registerContext.leadToLive.leadToLiveQualificationDetails,
                migrationRiskLines: migrationLossRisklines
            },
            lead: {
                ...registerContext.leadToLive.lead,
                currentERPName: currentErpName
            }
        });
        
        setCurrentERPName(currentErpName);
        setMigrations(newMigrations);
    }
    
    return (
        <Stack
            className={
                isSM ? 
                    smContainerStyles : 
                isMD ? 
                    mdContainerStyles :
                isLG ?
                    lgContainerStyles :
                isXL ?
                    xlContainerStyles :
                isXXL ?
                    xxlContainerStyles
                :
                    containerStyles
            }
        >
            <Stack
                className={
                    isSM ? 
                        smTitleContainerStyles : 
                    isMD ? 
                        mdTitleContainerStyles :
                    isLG ?
                        lgTitleContainerStyles :
                    isXL ?
                        xlTitleContainerStyles :
                    isXXL ?
                        xxlTitleContainerStyles
                    :
                        titleContainerStyles
                }
            >
                <Text 
                    className={
                        isSM ? 
                            smTitleStyles : 
                        isMD ? 
                            mdTitleStyles : 
                        isLG ?
                            lgTitleStyles :
                        isXL ?
                            xlTitleStyles :
                        isXXL ?
                            xxlTitleStyles
                        :
                            titleStyles
                    }
                >
                    {RegisterService.translate("migration:title")}
                </Text>
                <Text 
                    className={
                        isSM ? 
                            smSubTitleStyles : 
                        isMD ? 
                            mdSubTitleStyles :
                        isLG ?
                            lgSubTitleStyles :
                        isXL ?
                            xlSubTitleStyles :
                        isXXL ?
                            xxlSubTitleStyles
                        :
                            subTitleStyles
                    }
                >
                    {RegisterService.translate("migration:description")}
                </Text>
            </Stack>
            <Stack
                className={formContainerStyles}
            >
                <Stack>
                    <RegisterTextField 
                        autoFocus
                        onChange={(value) => {handleChanged(value)}}
                        placeholder={RegisterService.translate("migration:currentErpName")}
                        value={currentERPName}
                    />
                </Stack>
                <Stack
                    className={
                        isSM ?
                            smListContainerStyles :
                        isMD ?
                            mdListContainerStyles :
                        isLG ?
                            lgListContainerStyles :
                        isXL ?
                            xlListContainerStyles :
                        isXXL ?
                            xxlListContainerStyles
                        :
                            listContainerStyles
                    }
                >
                    {
                        migrations.map((value: RegisterMigration, index: number, array: RegisterMigration[]) => {
                            return (
                                <Row>
                                    <Col
                                        colClass={col12}
                                    >
                                        <RegisterMigrationRow 
                                            checked={value.selected}
                                            title={value.description}
                                            onChange={(checked) => handleChanged(currentERPName, {...value, selected: checked!})}
                                        />
                                    </Col>
                                </Row>
                            );
                        })
                    }
                </Stack>
            </Stack>
        </Stack>
    );
};